export default {
    templates: { list: { tags: [], templates: [], templateTypes: [] }, edit: [] }
};
